/** When your routing table is too long, you can split it into small modules**/

export default {
  title: '公告訊息維護',
  to: {
    path: '/nstc/view/bulletin',
  },
  action: 'manage',
  subject: 'BULLETIN',
}
